import { render, staticRenderFns } from "./_popover.vue?vue&type=template&id=0fc485fd&scoped=true&"
import script from "./_popover.vue?vue&type=script&lang=js&"
export * from "./_popover.vue?vue&type=script&lang=js&"
import style0 from "./_popover.vue?vue&type=style&index=0&id=0fc485fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc485fd",
  null
  
)

export default component.exports